import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnDestroy,
  signal,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, fromEvent, map, startWith, Subject } from 'rxjs';

import { HeaderService } from '../../../core/services/header';
import * as fromStore from 'src/app/store/';
import { environment } from 'src/environments/environment';
import { EditProfileDialogComponent } from '../../../core/edit-profile/edit-profile-user-dialog.component';
import { headerNavigation } from './header-navigation/header-navigation';
import { NavigationRecordService } from './navigation-record/navigation-record.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [NavigationRecordService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements OnDestroy {
  @Input() browserSize: string;

  readonly header$ = inject(HeaderService);

  private readonly matDialog$ = inject(MatDialog);

  private readonly destroy$ = new Subject<void>();

  readonly navigation$ = inject(NavigationRecordService).compileNavigation(
    headerNavigation,
  );

  readonly user$ = inject<Store<fromStore.State>>(Store).select(
    fromStore.getCurrentUser,
  );

  readonly mobileMenuOpen = signal(false);

  readonly siteUrl = environment.siteUrl;

  readonly windowWidth$ = toSignal(
    fromEvent(window, 'resize').pipe(
      takeUntilDestroyed(),
      map(() => window.innerWidth),
      startWith(window.innerWidth),
      map((width) => ({
        underLg: width <= 1024,
      })),
      distinctUntilChanged((prev, curr) => prev.underLg === curr.underLg),
    ),
  );

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  editProfile(): void {
    this.matDialog$.open(EditProfileDialogComponent, {
      autoFocus: true,
      width: '480px',
      data: {},
    });
  }

  handleNavAction(action: string): void {
    switch (action) {
      case 'editProfile':
        return this.editProfile();
      default:
        break;
    }
  }
}
